<div class="card flex justify-content-center" *ngIf="showModal">
    <div class="card flex justify-content-center">
        <p-confirmDialog #cd [style]="{width: '50vw'}">
            <ng-template pTemplate="header">
                <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                    <i class="pi pi-info text-5xl"></i>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button type="button" pButton label="Sim" (click)="cd.accept()"></button>
            </ng-template>
        </p-confirmDialog>
    </div>
</div>